// A flagged option only moves to the technical-properties popup
// (TechnicalPropertyOptions) when it has no children: the popup renders each
// option as a single staged row with no child-option disclosure, so a flagged
// option that has children stays in its normal column (rendered by
// OptionWithChildren) where its children still reach the form and every redraw.
const isTechnicalPropertyPopupOption = (option) => (
  option.technical_property && (option.children || []).length == 0
);

export default isTechnicalPropertyPopupOption;
